import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Typography,
  IconButton,
  TextField,
  MenuItem,
  Select,
  FormControl,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";

export default function AddModal({ open, handleClose }) {
  const [formData, setFormData] = useState({
    date: "",
    heure: "",
    direction: "",
    trajet: "",
    duree: "",
    distance: "",
    nomTrajet: "",
    vehicule: "",
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const inputStyle = {
    '& .MuiOutlinedInput-root': {
      height: 35,
      '&:hover fieldset': { borderColor: '#000' },
      '&.Mui-focused fieldset': { borderColor: 'red' }
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md" sx={{ "& .MuiPaper-root": { maxHeight: "none" } }}>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography variant="h6" sx={{ fontWeight: 400, mr: 3 }}>
          AJOUTER UNE NAVETTE
        </Typography>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography variant="subtitle2">Date de navette</Typography>
        <TextField fullWidth type="date" name="date" value={formData.date} onChange={handleChange} variant="outlined" sx={inputStyle} />
        <Typography variant="subtitle2">Durée</Typography>
        <TextField fullWidth type="text" name="duree" value={formData.duree} onChange={handleChange} variant="outlined" sx={inputStyle} />
        <Typography variant="subtitle2">Distance</Typography>
        <TextField fullWidth type="text" name="distance" value={formData.distance} onChange={handleChange} variant="outlined" sx={inputStyle} />
        <Typography variant="subtitle2">Nom du trajet</Typography>
        <TextField fullWidth type="text" name="nomTrajet" value={formData.nomTrajet} onChange={handleChange} variant="outlined" sx={inputStyle} />
        <Typography variant="subtitle2">Heure</Typography>
        <FormControl fullWidth sx={inputStyle}>
          <Select name="heure" value={formData.heure} onChange={handleChange}>
            <MenuItem value="08:00">08:00</MenuItem>
            <MenuItem value="12:00">12:00</MenuItem>
            <MenuItem value="18:00">18:00</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="subtitle2">Direction</Typography>
        <FormControl fullWidth sx={inputStyle}>
          <Select name="direction" value={formData.direction} onChange={handleChange}>
            <MenuItem value="Nord">Nord</MenuItem>
            <MenuItem value="Sud">Sud</MenuItem>
            <MenuItem value="Est">Est</MenuItem>
            <MenuItem value="Ouest">Ouest</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="subtitle2">Trajet</Typography>
        <FormControl fullWidth sx={inputStyle}>
          <Select name="trajet" value={formData.trajet} onChange={handleChange}>
            <MenuItem value="A">A</MenuItem>
            <MenuItem value="B">B</MenuItem>
          </Select>
        </FormControl>
        <Typography variant="subtitle2">Véhicule</Typography>
        <FormControl fullWidth sx={inputStyle}>
          <Select name="vehicule" value={formData.vehicule} onChange={handleChange}>
            <MenuItem value="Voiture">Voiture</MenuItem>
            <MenuItem value="Bus">Bus</MenuItem>
            <MenuItem value="Camion">Camion</MenuItem>
          </Select>
        </FormControl>
      </DialogContent>
      <Divider sx={{ mb: 1 }} />
      <DialogActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Button variant="outlined" sx={{ color: "red", borderColor: "red", textTransform: "none", "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } }} startIcon={<CloseIcon />} onClick={handleClose}>
          Close
        </Button>
        <Button variant="outlined" sx={{ color: "red", borderColor: "red", textTransform: "none", "&:hover": { backgroundColor: "red", color: "#fff", borderColor: "red" } }} startIcon={<CheckIcon />}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
